import React, { Component } from 'react';
import { Card, Container, Row, Col, Button, Image, Form } from 'react-bootstrap';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { sendPoll } from '../../api/PollService';
import './assessment.css';
import icono from '../../assets/images/icono_encuesta.svg';

class Assessment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      send: false,
      rating: 0,
      scoreSelected: true
    };
  }

  handleCancelAssement(){
    const { setRating } = this.props;
    setRating(0);
  }

  handleCommentChange = (e) => {
    const { setCommentAssesment } = this.props;
    const comment = e.target.value;
    setCommentAssesment(comment);
  }

  handleClickPoll(){
    const { send } = this.state;
    const { rating, comment, getSentValue} = this.props;

    if(!send){
      this.setState({send: true});
      getSentValue(true);
      if(rating>0){
        sendPoll(rating, comment);
      }
    }
    this.handleGoogleAnalytics();
  }

  handleGoogleAnalytics(){
    const { googleAnalytics } = this.props;
    googleAnalytics({'event':'vpv-privado','sitesection':'vpv-privado','page':'/tef/dap/encuesta'});
  }

  handleClick(value) {
    const { send } = this.state;
    const { setRating } = this.props;

    if (!send) {
      setRating(value)
    }
  }

  renderStars() {
    const stars = [];
    const { send } = this.state;
    const { rating } = this.props;

    for (let i = 1; i <= 7; i += 1) {
      stars.push(
        <Col key={i} md={1} xs={i <= 3 ? 4 : 3} id={"col"+i} className="centerContent">
          <Button
            className={rating === i ? 'buttonScore buttonScoreSelected' : 'buttonScore'}
            onClick={() => this.handleClick(i)}
            disabled={send}
          >{i}</Button>
        </Col>
      );
    }

    return stars;
  }

  render() {

    const { cleanSimulation, rating, comment} = this.props;
    const { send } = this.state;
    return (
        <div id="assesment" className="dap_assessment">
            <Card  className="card-asses">
            <Container>
              <Row noGutters>
                {!send && <Col md={2}/>}
                <Col md={2} sm={12} xs={12} className={ !send ? 'textCenter' : 'textCenter col-md-12 imgMargin'}>
                  <Image src={icono} className={!send ? 'icono_dap_poll' : 'icono_dap_poll imgExtra'} alt="Ícono DAP Poll" />
                </Col>
                {!send && <Col md={7} sm={12} xs={12} className="textCenter">
                  <h5>Tu opinión nos importa</h5>
                </Col>}
                {!send && <Col md={1}/>}
                {!send && <Col md={12}>
                  <p>
                    ¿Qué tan satisfecho estas con la contratación digital de tu{' '}
                    <b>Depósito a Plazo</b>?
                  </p>
                  <p className="colorSatisfaccion">
                    1 Muy insatisfecho / 7 Muy satisfecho
                  </p>
                </Col>}
              </Row>
              {!send && <Row noGutters className="justify-content-around">
                {this.renderStars()}
              </Row>}

              {(rating > 0 && !send) &&
              <div>
                <Row noGutters className="justify-content-around">
                  <Col lg={12} md={12} sm={12} xs={12}>
                  <Form.Group>
                    {rating <= 4 && <Form.Label className="lbl_assesment">Cuéntanos que problema tuviste (Requerido)</Form.Label>}
                    {(rating === 5 || rating === 6) && <Form.Label className="lbl_assesment">¿Deseas agregar un comentario? (Opcional)</Form.Label>}
                    {rating === 7 && <Form.Label className="lbl_assesment">¡Genial! Dinos que te gustó (Opcional)</Form.Label>}
                    <Form.Control
                      className="txt_assesment"
                      as="textarea" 
                      rows="3" 
                      maxlength="150"
                      value={comment}
                      onChange={this.handleCommentChange}
                    />
                  </Form.Group>
                  </Col>
                </Row>
                <Row className="row_count">
                  <Col md={8} sm={8} xs={8}>
                    {comment.length === 150 && <p className="lbl_count_assesment">Has alcanzado el límite de texto</p>}
                  </Col>
                  <Col md={4} sm={4} xs={4}>
                    <p className={comment.length < 150 ? 'count_assesment' : 'count_assesment red'}>{comment.length}/150</p>
                  </Col>
                </Row>
              </div>
              }

              {send &&
              <Row noGutters className="dap_assessment_major">
                <Col md={1} xs={1}/>
                <Col md={1} xs={1} className="dap_summary_right dap_assessment_comment">
                  <FontAwesomeIcon icon={faCheckCircle} className="dap_icon_major" color="#27ae60" />
                </Col>
                <Col md={9} xs={9} className="dap_assessment_comment">
                    <p className="dap_assessment_mobile">
                      <b>
                        Gracias, tu opinión nos ayuda a mejorar.
                      </b>
                    </p>
                </Col>
                <Col md={1} xs={1}></Col>
              </Row>
              }

              {(rating > 0 && !send) &&
              <Row>
                <Col md={6} sm={12} xs={12}>
                  <Button
                    onClick={() => this.handleCancelAssement()}
                    className="dap_btn-secondary secondary_extra"
                    type="submit"
                  >
                    Cancelar
                  </Button>
                </Col>
                <Col md={6} sm={12} xs={12}>
                  <Button
                    onClick={() => this.handleClickPoll()}
                    className="dap_btn-primary primary_extra"
                    type="submit"
                    disabled={rating < 5 && comment.length === 0}>
                    Responder
                  </Button>
                  
                </Col>

              </Row>
              }
              <Row>
                <Col md={12} sm={12} xs={12} className="text-center contentLink" >
                  <Link
                    to="/listado"
                    onClick={cleanSimulation}
                    className={!send ? 'linkVolver' : 'dap_btn-primary volverExtra'}
                  >
                    Volver a Depósitos a Plazo
                  </Link>
                </Col>
              </Row>
            </Container>
          </Card>
        </div>
        
    );
  };
}

export default Assessment;
